import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=0179f4cc&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=0179f4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179f4cc",
  null
  
)

export default component.exports